export default __webpack_public_path__ + "img/datelier-banner.5cd6a73d.jpg";